import React from 'react';
import { Link } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../constants/support';
import './Footer.css';

const Footer = () => {
  return (
    <footer className='rp-footer' role='contentinfo'>
      <div className='rp-footer-inner'>
        <div className='rp-footer-title'>YANGZHOU TECH // FOOTER</div>
        <hr className='rp-footer-rule' />
        <div className='rp-footer-row-head'>
          [COMPANY] &nbsp; [RESOURCES] &nbsp; [LEGAL]
        </div>
        <div className='rp-footer-grid'>
          <div className='rp-footer-col'>
            <Link to='/about'>Yangzhou Tech</Link>
            <span>&copy; 2026 All Rights Reserved</span>
            <span>China AI Computing Power</span>
            <span>Outbound Infrastructure</span>
          </div>
          <div className='rp-footer-col'>
            <Link to='/docs'>API Docs</Link>
            <Link to='/guide'>Developer Guide</Link>
            <Link to='/examples'>Code Examples</Link>
            <Link to='/pricing'>Pricing</Link>
          </div>
          <div className='rp-footer-col'>
            <Link to='/terms'>Terms of Service</Link>
            <Link to='/privacy'>Privacy Policy</Link>
            <Link to='/sla'>SLA Commitment</Link>
            <Link to='/aup'>Acceptable Use Policy</Link>
          </div>
        </div>
        <div className='rp-footer-contact'>
          Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className='rp-footer-contact-mail'>
            {SUPPORT_EMAIL}
          </a>{' '}
          | https://api.realitypatch.net
        </div>
      </div>
    </footer>
  );
};

export default Footer;
